/**
 * O catálogo de sistemas (injeção eletrônica, ABS, partida…) para escolher pelo
 * nome.
 *
 * É o mesmo `GET api/sistemas` — os sistemas em português, `base_id = 1`, como o
 * `SistemaDB.Listar()` do legado — e a mesma chave de cache da aba Sistemas do
 * projeto, então as duas telas dividem a lista.
 */

import { useQuery } from "@tanstack/react-query"
import { obter } from "@/api/cliente"

export type SistemaDoCatalogo = { id: number; nome: string; descricao: string }

export function usarCatalogoDeSistemas() {
  return useQuery({
    queryKey: ["catalogo-global", "sistemas"] as const,
    queryFn: () => obter<SistemaDoCatalogo[]>("api/sistemas", {}),
    staleTime: 10 * 60_000,
  })
}
